import React, { useEffect, useMemo, useState } from "react";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Button, { Color } from "../../../../../components/Form/Button";
import SubHeader from "../../../../../components/Generic/SubHeader";
import UITabMaterial, { PanelProps } from "../../../../../components/Generic/UITabMaterial";
import { PRIVATE_ROUTES } from "../../../../../constants";
import { useAppState } from "../../../../../context/StateContext";
import { useQueryURL } from "../../../../../hooks/useQueryURL";
import CustomerService from "../../../../../services/customer.service";
import { CompanyProfile } from "../../../../../util/enums";
import { CustomerScreen as Customer } from "../Customer";
import { checkResourceCan } from "Util/permissions";
import { ResourceCanEnum, ResourceName } from "Util/enums/accessRule";
import useStyles from "../styles";
import { isMoving } from "Util/validation";

interface SearchParams {
  tab?: string;
}

const CustomersPage = () => {
  const { t: translate } = useTranslation();
  const queries = useQueryURL<SearchParams>();
  const history = useHistory();

  const { currentUser, userPermissions } = useAppState();
  const classes = useStyles();

  const [customersCount, setCustomersCount] = useState<number>(0);
  const [canViewCustomers, setCanViewCustomers] = useState<boolean>(false);

  useEffect(() => {
    if (userPermissions && userPermissions.length > 0) {
      setCanViewCustomers(
        checkResourceCan(userPermissions, ResourceName.CUSTOMERS, ResourceCanEnum.VIEW)
      );
    }
  }, [userPermissions]);

  useQuery(
    ["customers.active.count", currentUser?.companyId],
    () =>
      CustomerService.count({
        companyId: currentUser?.companyId,
        status: "Active",
      }),
    {
      enabled: !!currentUser?.id,
      onSuccess: (response) => {
        if (response && response.data) setCustomersCount(response.data);
      },
    }
  );

  const customersPanel: PanelProps = useMemo(
    () => ({
      menuItem: translate("customers"),
      badgeValue: customersCount,
      className: classes.uiTab,
      key: "customers",
      render: () => <Customer />,
    }),
    [translate, customersCount, classes.uiTab]
  );

  const leftPanels = useMemo(() => {
    switch (currentUser?.company?.profile?.initials) {
      case CompanyProfile.MV:
      case CompanyProfile.FM:
      case CompanyProfile.SP:
      case CompanyProfile.ST:
      default:
        return canViewCustomers ? [customersPanel] : [];
    }
  }, [currentUser?.company?.profile?.initials, canViewCustomers, customersPanel]);

  const [selectedPanel, setSelectedPanel] = useState(0);

  useEffect(() => {
    const { tab } = queries("tab");
    if (tab && tab !== "customers") {
      history.replace(`${PRIVATE_ROUTES.CUSTOMERS}`);
    }
  }, []);

  useEffect(() => {
    const { tab } = queries("tab");
    if (tab) {
      history.replace(`${PRIVATE_ROUTES.CUSTOMERS}`);
    }
  }, [selectedPanel]);

  return (
    <div>
      {!isMoving(currentUser?.company) && (
        <SubHeader>
          {false && (
            <Button
              startIcon={<InsertLinkIcon htmlColor="#FFFFFF" />}
              customColor={Color.SECONDARY}
              className={classes.buttonLink}
              data-cy="button-link-account"
            >
              {translate("linkAccounts")}
            </Button>
          )}
        </SubHeader>
      )}

      <div className={classes.mainDiv}>
        <UITabMaterial
          leftPanels={leftPanels}
          selectedLeftPanel={selectedPanel}
          onChangeLeftPanel={(_, panel) => setSelectedPanel(panel)}
        />
      </div>
    </div>
  );
};

export default CustomersPage;
